import React, {useState} from "react";
import {
    SingleDatePicker,
    DayPickerSingleDateController,
    DayPickerSingleDateControllerShape,
    SingleDatePickerShape
} from 'react-dates';
import moment from 'moment';
import {css} from '@emotion/react';
import 'react-dates/initialize';
import './styles.scss';
import TextField from '@atlaskit/textfield';
import Popup from '@atlaskit/popup';
import Select from 'components/select';

interface DatePickerProps extends SingleDatePickerShape {
    value?: string;
}

const defaultProps: DatePickerProps =  {
    id: "",
    focused: false,
    date: null,
    onDateChange: () => null,
    onFocusChange: (p1: { focused: boolean | null }) => null,
    // input related props
    // placeholder: 'Date',
    // disabled: false,
    // required: false,
    // screenReaderInputMessage: '',
    // showDefaultInputIcon: true,
    // block: false,
    // small: false,
    // regular: false,
    // verticalSpacing: undefined,
    // keepFocusOnInput: false,

    // calendar presentation and interaction related props
    // orientation: HORIZONTAL_ORIENTATION,
    // anchorDirection: ANCHOR_LEFT,
    // horizontalMargin: 0,
    // withPortal: false,
    // withFullScreenPortal: false,
    numberOfMonths: 1,
    // keepOpenOnDateSelect: false,
    // isRTL: false,

    // navigation related props
    // onPrevMonthClick() {},
    // onNextMonthClick() {},
    // onClose() {},

    // day presentation and interaction related props
    // renderCalendarDay: undefined,
    // enableOutsideDays: true,
    // isDayBlocked: () => false,
    isOutsideRange: day => false,
    transitionDuration: 0,
    // isOutsideRange: day => !isInclusivelyAfterDay(day, moment()),
    // isDayHighlighted: () => {},

    // internationalization props
    monthFormat: 'MMMM YYYY',

    hideKeyboardShortcutsPanel: true
};

const DatePickerBeta = (props: DatePickerProps) => {
    // @ts-ignore
    const { field, form: { touched, errors, setFieldValue }, isInvalid, children, ...singleDatePickerProps} = props;
        const [focused, setFocused] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState(true);

    console.log('rerender DatePickerBeta')
    // @ts-ignore
    // const Menu = ({selectProps}) => (
    //     <DayPickerSingleDateController
    //         {...singleDatePickerProps}
    //         date={moment(field.value, 'YYYY-MM-DD')}
    //         focused={true}
    //         onDateChange={(date: moment.Moment | null) => {
    //             if(date){
    //                 console.log('date', date.format('YYYY-MM-DD'));
    //                setFieldValue(field.name, date.format('YYYY-MM-DD'));
    //               setIsOpen(false)
    //         }
    //     }}
    //     // onFocusChange={(arg: { focused: boolean | null }) => setFocused(focused)}
    //     />)

    // const selectComponents = {
    //     Menu,
    // };

    return <SingleDatePicker
        {...props}
        id={'date'}
        date={moment(field.value, 'YYYY-MM-DD')}
        onDateChange={(date: moment.Moment | null) => {
            if(date){
                console.log('date', date.format('YYYY-MM-DD'));
                setFieldValue(field.name, date.format('YYYY-MM-DD'));
                setIsOpen(false)
            }}}
        focused={focused}
        onFocusChange={(arg: { focused: boolean | null }) => setFocused(!focused)}
/>
    // return (
    //     <React.Fragment>
    //         <Popup
    //             isOpen={isOpen}
    //             onClose={() => setIsOpen(false)}
    //             placement="bottom-start"
    //             content={() => (
    //                 <DayPickerSingleDateController
    //                     {...singleDatePickerProps}
    //                     date={moment(field.value, 'YYYY-MM-DD')}
    //                     // focused={false}
    //                     onDateChange={(date: moment.Moment | null) => {
    //                         if(date){
    //                             console.log('date', date.format('YYYY-MM-DD'))
    //                             setFieldValue(field.name, date.format('YYYY-MM-DD'));
    //                             setIsOpen(false)
    //                         }
    //                     }}
    //                     // onFocusChange={(arg: { focused: boolean | null }) => setFocused(focused)}
    //                 />
    //             )}
    //             trigger={triggerProps => (
    //                 <TextField
    //                     {...field}
    //                     {...triggerProps}
    //                    onFocus={(e)=> {setIsOpen(true); field.onFocus && field.onFocus(e)}}
    //                    // onBlur={(e)=> {setIsOpen(false); field.onBlur && field.onBlur(e)}}
    //                 />
    //
    //                 // <Button
    //                 //     {...triggerProps}
    //                 //     isSelected={isOpen}
    //                 //     onClick={() => setIsOpen(!isOpen)}
    //                 //     iconBefore={<MediaServicesAddCommentIcon label="Add" />}
    //                 // />
    //             )}
    //         />
    //
    //     </React.Fragment>
    //     );
};
DatePickerBeta.defaultProps = defaultProps;

export default DatePickerBeta;
